import { Switch } from 'src/design/atoms/Switch';
import { Textarea } from 'src/design/atoms/Textarea';
import React from 'react';
import { formatDate } from 'src/utils';

import { DailyQuestionAnswer } from 'src/api/FiretrolApiClient';
import { DailyQuestions } from 'src/routes/Operations/Daily/components/DailyQuestions';
import { StepProps } from './types';

export interface QuestionsStepProps extends StepProps {
  onQuestionsChange: (questions: DailyQuestionAnswer[]) => void;
}

export const QuestionsStep: React.FC<QuestionsStepProps> = ({
  values,
  setFieldValue,
  setFieldTouched,
  selectedJob,
  onQuestionsChange,
}) => {
  return (
    <>
      <Switch
        label={`No Questions for ${formatDate(values.date)}`}
        checked={values.excludeQuestions}
        onChange={(event) => {
          setFieldValue('excludeQuestions', event.currentTarget.checked);
          setFieldTouched('excludeQuestions', true, false);
        }}
      />

      {values.excludeQuestions && (
        <Textarea
          label="Reason for exclusion"
          placeholder="Explain why questions are excluded..."
          value={values.exclusionQuestionsReason || ''}
          onChange={(e) =>
            setFieldValue('exclusionQuestionsReason', e.target.value)
          }
          maxLength={1000}
          rows={3}
          mt="md"
        />
      )}

      {!values.excludeQuestions && selectedJob && (
        <DailyQuestions
          jobId={selectedJob.id}
          questions={values.questions}
          onQuestionsChange={onQuestionsChange}
        />
      )}
    </>
  );
};
